import script from "./JobFinder.vue?vue&type=script&setup=true&lang=js"
export * from "./JobFinder.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__